import { Link } from 'react-router-dom';
import SectionHeading from '@/components/feature/SectionHeading';
import { categories } from '@/mocks/categories';
import { stories } from '@/mocks/stories';

const colorMap: Record<string, { bg: string; text: string; ring: string }> = {
  primary: { bg: 'bg-primary-100', text: 'text-primary-700', ring: 'group-hover:border-primary-300' },
  accent: { bg: 'bg-accent-100', text: 'text-accent-700', ring: 'group-hover:border-accent-300' },
  secondary: { bg: 'bg-secondary-100', text: 'text-secondary-900', ring: 'group-hover:border-secondary-300' },
};

export default function CategorySection() {
  return (
    <section className="border-b border-background-200 bg-background-100/50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-content px-4 md:px-6">
        <SectionHeading
          eyebrow="主题分类"
          title="按你感兴趣的场景逛一逛"
          desc="五个板块覆盖校园生活的主要场景，点进去就能看到对应分类下的全部高校吃瓜日常。"
          align="center"
        />

        <div className="mt-10 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4 lg:auto-rows-[180px]">
          {categories.map((cat, index) => {
            const count = stories.filter((s) => s.categorySlug === cat.slug).length;
            const tone = colorMap[cat.color] ?? colorMap.primary;
            const isBig = index === 0;

            return (
              <Link
                key={cat.slug}
                to={`/stories?category=${cat.slug}`}
                className={`group flex flex-col justify-between rounded-lg border border-background-200 bg-background-50 p-5 transition-colors ${tone.ring} ${
                  isBig ? 'md:col-span-2 lg:col-span-2 lg:row-span-2' : ''
                }`}
              >
                <div>
                  <span
                    className={`flex h-11 w-11 items-center justify-center rounded-md ${tone.bg} ${tone.text}`}
                  >
                    <i className={`${cat.icon} text-xl`} />
                  </span>
                  <h3 className={`mt-4 font-heading font-bold text-foreground-950 ${isBig ? 'text-2xl' : 'text-lg'}`}>
                    {cat.name}
                  </h3>
                  <p className={`mt-2 text-sm leading-relaxed text-foreground-600 ${isBig ? 'max-w-sm' : 'line-clamp-2'}`}>
                    {cat.desc}
                  </p>
                </div>
                <div className="mt-4 flex items-center justify-between">
                  <span className="text-xs text-foreground-500">已收录 {count * 8 + 6} 篇</span>
                  <i className="ri-arrow-right-up-line text-foreground-400 transition-all group-hover:translate-x-1 group-hover:text-primary-500" />
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}